"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SERVER_URL = 'http://localhost:8080';
exports.default = { SERVER_URL: SERVER_URL };
// TODO: env
